import PropTypes from 'prop-types';
import { Modal, Backdrop, Box } from '@material-ui/core';
import SnapshotSummary from './SnapshotSummary';

SnapshotPreviewModal.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
};

export default function SnapshotPreviewModal({ data, isOpen, setIsOpen }) {
  return (
    <Box>
      <Modal
        open={isOpen}
        aria-labelledby="Preview-Modal"
        aria-describedby="General Modal for viewing data"
        BackdropComponent={Backdrop}
        data-testid="preview-modal"
      >
        <Box>
          <SnapshotSummary data={data} isOpen={isOpen} setIsOpen={setIsOpen} />
        </Box>
      </Modal>
    </Box>
  );
}
